module.exports = __webpack_public_path__ + "static/media/POOL-201-badge.9e24b687.svg";